module.exports = __webpack_public_path__ + "4ddabf5cea4b727b67dfec527ac3fab6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/rmzxb_g.png
// module id = 243
// module chunks = 3